import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { TextLink } from 'secondstep-components'

export const DropdownWrapper = styled.div`
  position: relative;
  display: flex;
`

export const TabSlot = styled.div`
  display: flex;
  align-items: center;
`

export const TabCaret = styled.span.attrs(props => ({
  color: props.isActive
    ? themeGet('colors.themePrimary')(props)
    : themeGet('colors.mediumGray')(props),
}))`
  display: flex;
  flex-shrink: 0;
  margin-left: 0.25rem;
  color: ${({ color }) => color};
  cursor: default;

  svg {
    width: 0.5625rem;
    height: auto;
  }
`

export const DropdownPositioner = styled.div`
  position: absolute;
  top: 100%;
  left: -1rem;
  z-index: 10;
  padding-top: 0.1875rem;
`

export const DropdownPanel = styled.ul`
  min-width: 10rem;
  margin: 0;
  padding: 0.75rem 1rem;
  list-style: none;
  white-space: nowrap;
  background-color: ${themeGet('programNav.backgroundColor', 'white')};
  box-shadow: ${themeGet('programNav.boxShadow')};
`

export const SectionLabel = styled.li`
  margin-bottom: 0.5rem;
  padding-bottom: 0.375rem;
  border-bottom: 1px solid ${themeGet('colors.gray300', '#dee2e6')};
  color: ${themeGet('colors.mediumGray')};
  font-family: ${themeGet('fontFamily')};
  font-size: 0.625rem;
  letter-spacing: 0.05rem;
  text-transform: uppercase;

  &:not(:first-child) {
    margin-top: 0.75rem;
  }
`

export const DropdownItem = styled.li`
  & + & {
    margin-top: 0.25rem;
  }
`

export const DropdownLink = styled(TextLink).attrs(props => {
  const { isActive } = props
  const fontFamily = isActive
    ? themeGet('fontFamilySemibold')(props)
    : themeGet('fontFamily')(props)
  const color = isActive
    ? themeGet('colors.themePrimary')(props)
    : themeGet('colors.mediumGray')(props)

  return {
    color,
    fontFamily,
  }
})`
  padding: 0.25rem 0;
  color: ${({ color }) => color};
  font-family: ${({ fontFamily }) => fontFamily};
  font-size: 0.875rem;
`
